import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  InputAuto,
  InputDate,
  InputImg,
  InputMultImg,
  InputPass,
  Select,
} from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { Alert, Form, Tabs } from "../../layout";
import { PassValidation } from "../../utils";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { NestedFormData, RmvEmptyProp } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditUser = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [imgSrc, setImgSrc] = useState([]);
  const [cities, setCities] = useState([]);
  const { Gender, Role, Languages } = DropLi();
  const { branch } = useContext(AppContext);
  const { UserMdl } = Model();

  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    setValues,
    handleFile,
    handleInpPass,
    passValid,
  } = UseForm(UserMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    id &&
      API(endpoints.User + actions.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = res.result;
          setValues((x) => ({ ...x, ...val, idProofFiles: [] }));
          setImgSrc(val.idProofs.map((j) => ({ ...j, src: j.idUrl })));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    branch.id &&
      API(endpoints.City + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setCities([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const validateForm = () => {
    let temp = {};
    temp.firstName = values.firstName !== "" ? "" : t("ValFirstName");
    temp.lastName = values.lastName !== "" ? "" : t("ValLastName");
    temp.email = values.email !== "" ? "" : t("ValEmail");
    temp.role = values.role !== "" ? "" : t("ValRole");
    if (!values.id || values.password) {
      temp.password = values.password !== "" ? "" : t("ValPass");
      temp.confirmPass =
        values.confirmPass !== ""
          ? values.confirmPass === values.password
            ? ""
            : t("ValPassNotMatch")
          : t("ValConfPass");
    }

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && branch.id) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Success"),
              subTitle: `${t("User")} ${id ? t("Update") : t("Added")} ${t(
                "Successfully"
              )}.`,
              onClick: () => navigate("/users"),
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("Error"),
              subTitle: res.msg,
            });
        }
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        API(endpoints.User + actions.Post).post(
          NestedFormData(RmvEmptyProp(values), "idProofFiles"),
          onComplete
        );
      } else {
        API(endpoints.User + actions.Put).put(
          NestedFormData(RmvEmptyProp(values), "idProofFiles"),
          onComplete
        );
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {id ? t("Edit") : t("Add")} {t("User")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15">
            <Tabs
              className="mt-30"
              header={[
                { label: t("GeneralFields"), icon: "" },
                { label: t("AdditionalFields"), icon: "" },
              ]}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("FirstName")}
                    name="firstName"
                    required={true}
                    value={values.firstName}
                    error={errors.firstName}
                    inputProps={{ maxLength: 255 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("LastName")}
                    name="lastName"
                    required={true}
                    value={values.lastName}
                    error={errors.lastName}
                    inputProps={{ maxLength: 255 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("Email")}
                    name="email"
                    required={true}
                    value={values.email}
                    error={errors.email}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Select
                    label={t("UserRole")}
                    name="role"
                    required={true}
                    value={values.role}
                    error={errors.role}
                    onChange={handleInpChg}
                    options={Role}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputPass
                    label={t("Password")}
                    name="password"
                    value={values.password}
                    required={true}
                    onChange={handleInpPass}
                    error={errors.password}
                    className="input-primary w-100pr"
                  />
                  <PassValidation
                    {...{ password: values.password, passValid }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputPass
                    label={t("ConfirmPassword")}
                    name="confirmPass"
                    required={true}
                    value={values.confirmPass}
                    onChange={(e) => handleInpPass(e, true)}
                    error={errors.confirmPass}
                    className="input-primary w-100pr"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Select
                    label={t("Gender")}
                    name="gender"
                    value={values.gender}
                    error={errors.gender}
                    onChange={handleInpChg}
                    options={Gender}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputDate
                    label={t("DateOfBirth")}
                    name="dob"
                    value={values.dob}
                    error={errors.dob}
                    maxDate={new Date()}
                    onChange={(date) =>
                      handleInpDate("dob", new Date(date).toLocaleDateString())
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("Phone")}
                    name="phone"
                    value={values.phone}
                    error={errors.phone}
                    inputProps={{ maxLength: 50 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputAuto
                    label={t("City")}
                    name="cityId"
                    value={values.cityId}
                    error={errors.cityId}
                    onChange={handleInpChg}
                    options={cities}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("State")}
                    name="state"
                    value={values.state}
                    error={errors.state}
                    inputProps={{ maxLength: 300 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("ZIP")}
                    name="zip"
                    value={values.zip}
                    error={errors.zip}
                    inputProps={{ maxLength: 50 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputAuto
                    label={t("Language")}
                    name="language"
                    value={values.language}
                    error={errors.language}
                    onChange={handleInpChg}
                    options={Languages}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Input
                    label={t("Address")}
                    name="address"
                    value={values.address}
                    error={errors.address}
                    inputProps={{ maxLength: 600 }}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Input
                    label={t("Note")}
                    name="note"
                    value={values.note}
                    error={errors.note}
                    inputProps={{ maxLength: 500 }}
                    multiline
                    rows={3}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className="d-flex flex-wrap g-10">
                    <InputImg
                      label={t("ProfilePhoto")}
                      name="photoFile"
                      src={values.photo}
                      value={values.photoFile}
                      rmv={() => {
                        setValues({ ...values, photoFile: "", photo: "" });
                      }}
                      onChange={handleFile}
                      error={errors.photoFile}
                    />
                    <InputMultImg
                      label={t("IDProof")}
                      name="idProofFiles"
                      maxUpl={2}
                      src={imgSrc}
                      values={values.idProofFiles}
                      onChange={handleFile}
                      rmv={(file) => {
                        setValues((x) => ({
                          ...x,
                          idProofFiles: x.idProofFiles.filter(
                            (j) => j.lastModified !== file.lastModified
                          ),
                          idProofs: x.idProofs.filter((j) => j.id !== file.id),
                        }));
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={8} md={10}></Grid>
              </Grid>
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditUser;
